import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

/**
 * Универсальная модалка на MUI Dialog
 */
function ModalWithContent({ content, isOpen, onClose, title, maxWidth = 'lg' }) {
    return (
        <Dialog
            open={isOpen}
            // Закрытие по mousedown на подложке, а не по click: отпускание мыши вне модалки
            // (после выделения текста внутри) закрывать её не должно.
            onClose={(event, reason) => { if (reason !== 'backdropClick') onClose(); }}
            BackdropProps={{ onMouseDown: onClose }}
            maxWidth={maxWidth}
            fullWidth
            scroll="paper"
            PaperProps={{
                sx: {
                    maxHeight: { xs: '95vh', sm: '90vh' },
                    position: 'relative',
                    m: { xs: 1, sm: 2 }
                }
            }}
        >
            {/* Кнопка закрытия */}
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: 'grey.500',
                    zIndex: 1
                }}
            >
                <CloseIcon />
            </IconButton>

            {/* Заголовок */}
            {title && (
                <DialogTitle sx={{ pr: 6 }}>
                    {title}
                </DialogTitle>
            )}

            {/* Контент */}
            <DialogContent
                sx={{
                    pt: { xs: 2, sm: 4 },
                    pb: { xs: 2, sm: 3 },
                    px: { xs: 1.5, sm: 3 }
                }}
            >
                {content}
            </DialogContent>
        </Dialog>
    );
}

export default ModalWithContent;
